import gql from 'graphql-tag';

export const DeleteParticipantEmbeddableForm = gql`
  mutation DeleteParticipantEmbeddableForm(
    $organizationId: ID!
    $participantId: ID!
    $participantEmbeddableFormId: ID!
  ) {
    deleteParticipantEmbeddableForm(
      organizationId: $organizationId
      participantId: $participantId
      participantEmbeddableFormId: $participantEmbeddableFormId
    ) {
      id
    }
  }
`;
